<template>
  <v-container>
    <v-dialog v-model="openFlag" persistent max-width="600px">
      <c-card class="white" title="카드결제상세정보">
        <v-container>
          <v-row align="center" v-if="openFlag">
            <v-col cols="12" md="4" sm="4">
              <span class="ml-1 mb-2">상품명</span>
            </v-col>
            <v-col cols="12" md="8" sm="8">
              <span>{{ driveLogCardLogData.goodName }}</span>
            </v-col>
            <v-col cols="12" md="4" sm="4">
              <span class="ml-1 mb-2">결제금액</span>
            </v-col>
            <v-col cols="12" md="8" sm="8">
              <span>{{ driveLogCardLogData.prGoods }}</span>
            </v-col>
            <v-col cols="12" md="4" sm="4">
              <span class="ml-1 mb-2">결제 카드</span>
            </v-col>
            <v-col cols="12" md="8" sm="8">
              <span>{{ driveLogCardLogData.cardNm }}</span>
            </v-col>
            <v-col cols="12" md="4" sm="4">
              <span class="ml-1 mb-2">주문Key</span>
            </v-col>
            <v-col cols="12" md="8" sm="8">
              <span>{{ driveLogCardLogData.orderKey }}</span>
            </v-col>
            <v-col cols="12" md="4" sm="4">
              <span class="ml-1 mb-2">거래번호</span>
            </v-col>
            <v-col cols="12" md="8" sm="8">
              <span>{{ driveLogCardLogData.tid }}</span>
            </v-col>
            <v-col cols="12" md="4" sm="4">
              <span class="ml-1 mb-2">승인번호</span>
            </v-col>
            <v-col cols="12" md="8" sm="8">
              <span>{{ driveLogCardLogData.noAppl }}</span>
            </v-col>
            <v-col cols="12" md="4" sm="4">
              <span class="ml-1 mb-2">승인 시간</span>
            </v-col>
            <v-col cols="12" md="8" sm="8">
              <span>{{ driveLogCardLogData.appDate }} {{ driveLogCardLogData.appTime }}</span>
            </v-col>
            <template v-if="!driveLogCardLogData.noCancel">
              <v-col cols="12" md="4" sm="4">
                <span class="ml-1 mb-2">거래 결과</span>
              </v-col>
              <v-col cols="12" md="8" sm="8">
                <span>{{ driveLogCardLogData.result }} : {{ driveLogCardLogData.msg }}</span>
              </v-col>
            </template>
            <template v-else>
              <v-col cols="12" md="4" sm="4">
                <span class="ml-1 mb-2">취소승인번호</span>
              </v-col>
              <v-col cols="12" md="8" sm="8">
                <span>{{ driveLogCardLogData.noCancel }}</span>
              </v-col>
              <v-col cols="12" md="4" sm="4">
                <span class="ml-1 mb-2">취소 시간</span>
              </v-col>
              <v-col cols="12" md="8" sm="8">
                <span>{{ driveLogCardLogData.cancelDate }} {{ driveLogCardLogData.cancelTime }}</span>
              </v-col>
              <v-col cols="12" md="4" sm="4">
                <span class="ml-1 mb-2">취소 결과</span>
              </v-col>
              <v-col cols="12" md="8" sm="8">
                <span>{{ driveLogCardLogData.result }} : {{ driveLogCardLogData.msg }}</span>
              </v-col>
            </template>
          </v-row>
          <v-row justify="center">
            <c-btn class="mt-2" color="gray" outlined @click="openFlag = false">닫기</c-btn>
          </v-row>
        </v-container>
      </c-card>
    </v-dialog>
  </v-container>
</template>
<script>
  export default {
    props: {
      open: {
        type: Boolean,
        default: false
      },
      driveLogCardLogData: {
        type: Object,
        default: undefined
      }
    },
    data: () => ({
      openFlag: false,
    }),
    watch: {
      open(newVal) {
        this.openFlag = newVal;
      },
      openFlag(value) {
        this.$emit('update:open', value);
      },
    },
    computed: {
    },
    methods: {
    },
    mounted() {
    }
  }
</script>
